<template>
  <div class="wrapper">
    <div class="content-container">
      <div class="stingy-card">
        <h2 class="card-title">🐾 StingyCat's Wise Whiskers: The 24-Hour Cooling Off Purr-iod 🐾</h2>
        <p class="card-text">Before you swipe that card or click that "Buy Now" button, let's paws for a moment—yes, you heard me, paws! 🐾 You see, in the cat world, we have a secret: the best decisions are often made after a good catnap. That's right, even the most tempting ball of yarn looks less appealing after some beauty sleep. 😺💤<br><br>Introducing the 24-Hour Cooling Off Purr-iod. Before making any purchase, big or small, take 24 hours to 'sleep on it.' Dream away in your cozy cat-bed of wisdom and wake up with a clearer mind.</p>
        <img src="@/assets/bengraham2.png" alt="cat sleeping" class="cat-image">
        <p class="card-text">🐱 Do I really need this, or is it just a momentary whisker twitch?<br>🐱 Can I afford it without digging into my litter box of savings?<br>🐱 Have I compared prices? Maybe there's a less expensive scratching post that's just as good.</p>
        <p class="reminder-text">Remember, the best financial decisions aren't rushed; they're pondered and purr-fected. So take that catnap, and let your financial worries sleep away. After 24 hours, if you still think it's a purr-fect choice, go ahead and make that purchase. We'll help you track when it's over or you can also whip out your purr-ecision instrument (your phone!) and set an alarm, so you don't miss the end of your catnap decision time! 🐱⏰</p>
        <p class="zen-moment">Until then, let's enjoy a meow-ment of zen. 🐾🌙</p></div>
        <div v-if="!coolOffActive" class="input-section">
          <input type="text" v-model="purchaseName" placeholder="Enter item name" class="text-input">
          <input type="number" v-model="purchaseAmount" placeholder="Enter item price" class="number-input">
          <button @click="startCoolOff" class="start-button">Start Cool Off</button>
        </div>
        <div v-else class="timer-section">
          <p class="purchase-info"><strong>Considering buying: {{ purchaseName }}</strong></p>
          <p class="timer-info">Time remaining for cool-off: {{ timeRemaining }}</p>
          <button @click="resetCoolOff" class="reset-button">Reset Timer</button>
          
        </div>
      </div><iframe height="700" class="timer" style="width: 100%;" scrolling="no" title="Hourglass" src="https://codepen.io/Farah-Kamal/embed/BavbvGQ?default-tab=result&theme-id=47174" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true"></iframe>
    </div>
  <br><br><br><br><br><br>
</template>
  
  <script>
export default {
  data() {
    return {
      purchaseName: '',
      purchaseAmount: 0,
      timerEnd: null,
      coolOffActive: false,
      timeRemaining: ''
    };
  },
  computed: {
    formattedPurchaseAmount() {
      return `$${this.purchaseAmount}`;
    },
  },



  methods: {
    startCoolOff() {
      this.timerEnd = Date.now() + 48 * 60 * 60 * 1000;
      localStorage.setItem('purchaseName', this.purchaseName);
      localStorage.setItem('purchaseAmount', this.purchaseAmount);
      localStorage.setItem('timerEnd', this.timerEnd);

      this.coolOffActive = true;
      this.startCountdown();
    },
    startCountdown() {
      const interval = setInterval(() => {
        const now = Date.now();
        const distance = this.timerEnd - now;

        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.timeRemaining = `${hours}h ${minutes}m ${seconds}s`;

        if (distance < 0) {
          clearInterval(interval);
          this.coolOffActive = false;
          localStorage.removeItem('purchaseName');
          localStorage.removeItem('purchaseAmount');
          localStorage.removeItem('timerEnd');
        }
      }, 1000);
    },
    resetCoolOff() {
      this.coolOffActive = false;
      localStorage.removeItem('purchaseName');
      localStorage.removeItem('purchaseAmount');
      localStorage.removeItem('timerEnd');
    }
  },
  mounted() {
    this.purchaseName = localStorage.getItem('purchaseName') || '';
    this.purchaseAmount = localStorage.getItem('purchaseAmount') || 0;
    this.timerEnd = localStorage.getItem('timerEnd') || null;

    if (this.timerEnd && Date.now() < this.timerEnd) {
      this.coolOffActive = true;
      this.startCountdown();
    }
  }
};
</script>

<style scoped>
.wrapper {
display: flex;
flex-direction: column;
align-items: center;
}

.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}


.card-title {
  color: #4A148C;
  font-weight: bold;
}

.card-text, .reminder-text, .zen-moment {
  color: #333;
  line-height: 1.6;
}

.cat-image {
  width: 100%;
  max-width: 350px; /* Adjust as needed */
  height: auto;
  margin: 20px 0;
}

.input-section, .timer-section {
  margin-top: 20px;
  text-align: center;
}

.text-input, .number-input {
  padding: 10px;
  margin: 10px 0;
  border-radius: 5px;
  border: 2px solid #A596F3;
}

.start-button, .reset-button {
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #4A148C;
  color: white;
  margin-top: 10px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
}

.start-button:hover, .reset-button:hover {
  background-color: #361E6C;
  transform: scale(1.05);
}

.purchase-info, .timer-info {
  color: white;
  margin: 10px 0;
  font-weight: bold;
}
</style>